import { useAuditConfig } from '../../hooks/useAuditLog.js';
import { useUsersConfig } from '../../hooks/useUsers.js';
import type { NavVisibility } from './navSections.js';

/** The two "is this feature on" flags `visibleNavLinks` hides items on — plain values so memoisation downstream holds. */
export const useNavVisibility = (): NavVisibility => ({
    auditConfigured: useAuditConfig().configured,
    usersConfigured: useUsersConfig().configured,
});
